import { render, staticRenderFns } from "./ReceivablesByPayer.vue?vue&type=template&id=6315da12&"
import script from "./ReceivablesByPayer.vue?vue&type=script&lang=js&"
export * from "./ReceivablesByPayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports